module.exports = __webpack_public_path__ + "static/media/mls.497021a6.png";